import React from 'react'

import { AppsStreamelementsView } from './AppsStreamelementsView'
import { useStreamelements } from './hooks/useStreamelements'

export const AppsStreamelementsContainer = () => {
  const { streamelements } = useStreamelements()

  return <AppsStreamelementsView connectBar={streamelements.connectBar} />
}
